module.exports = __webpack_public_path__ + "img/sobre.59533d6d.jpeg";